import React from 'react';

const LaborLawText = () => {
  return (
    <div
      style={{
        fontSize: '22px',
        fontWeight: '400',
        lineHeight: '1.2',
        
        fontFamily: 'Times New Roman, Times, serif',
        color: "#555555"
      }}>

      <p style={{ marginBottom: '10px', fontSize: 22 }}>
        <strong>A Review of the Amended Egyptian Competition Law: Pre-Merger Control Regime</strong>
      </p>

      <p style={{ marginBottom: '20px' }}>
        On 2nd January 2024, Egypt's Senate bestowed preliminary approval upon a
        new labor law, sparking spirited debate amongst legal scholars, unions,
        and employers alike.
      </p>
      <p style={{ marginBottom: '20px' }}>
        {' '}
        This revamped framework, aiming to regulate the relationship between
        employer and employee in a dynamic market economy, demands a closer
        examination through the lens of legal perspective.
      </p>
      <h2 style={{ marginBottom: '20px' }}>
        <strong>Modernizing the Framework</strong>
      </h2>
      <p style={{ marginBottom: '20px' }}>
        The existing labor law, dating back to 1981, faced criticism for failing
        to fully address the complexities of the 21st-century workforce. The new
        law strives to remedy this by:
      </p>
      <ul style={{ marginBottom: '20px' }}>
        <li style={{ marginBottom: '20px' }}>
          Embracing Flexibility: Recognizing the increasing prevalence of
          part-time and remote work arrangements, the law incorporates
          provisions ensuring fair treatment and social security benefits for
          these non-traditional employment models.
        </li>
        <li style={{ marginBottom: '20px' }}>
          Enhancing Worker Protections: Stronger measures, including stricter
          rules on overtime and stricter penalties for non-payment of wages, aim
          to safeguard employee rights and deter exploitative practices.
        </li>
        <li style={{ marginBottom: '20px' }}>
          Promoting Gender Equality: Clauses guaranteeing equal pay for equal
          work and combating workplace discrimination based on gender are
          crucial steps towards a more equitable labor market.
        </li>
      </ul>
      <p style={{ marginBottom: '20px' }}>
        Egypt's evolving economic landscape necessitates this legal
        modernization: Private Sector Growth: With the private sector accounting
        for around 80% of the workforce, the law's focus on flexibility and
        adaptability aligns with this dynamic segment's needs.
      </p>
    </div>
  );
};

export default LaborLawText;
